import { useState } from 'react';
import { ArrowLeft, Check } from 'lucide-react';
import { traducirErrorBackend } from '@renderer/lib/mensajesError';

interface Props {
  onFinalizar: () => Promise<void> | void;
  onAtras: () => void;
}

export function Step5Demo({ onFinalizar, onAtras }: Props) {
  const [cargarDemo, setCargarDemo] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFinalizar = async () => {
    setEnviando(true);
    setError(null);
    const res = await window.api.onboarding.guardarPaso(5, { cargarDemo });
    if (!res.ok) {
      setError(traducirErrorBackend(res.error, res.codigo));
      setEnviando(false);
      return;
    }
    await onFinalizar();
  };

  return (
    <div className="mx-auto max-w-xl space-y-6">
      <div className="text-center">
        <h1 className="text-2xl font-bold">¡Casi terminamos!</h1>
        <p className="mt-2 text-slate-500">
          Podemos cargar algunos productos de ejemplo para que veas cómo funciona la app.
          Puedes borrarlos cuando quieras.
        </p>
      </div>

      <div className="card space-y-4">
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={cargarDemo}
            onChange={(e) => setCargarDemo(e.target.checked)}
            className="mt-1 h-4 w-4"
          />
          <span>
            <span className="font-medium">Sí, cargar productos de ejemplo</span>
            <span className="ml-2 rounded bg-green-100 px-2 py-0.5 text-xs text-green-700">recomendado</span>
          </span>
        </label>

        {cargarDemo && (
          <div className="rounded-lg bg-slate-50 p-4 text-sm text-slate-700">
            <p className="mb-2 font-medium">Se agregarán:</p>
            <ul className="space-y-1 pl-4">
              <li>• 3 productos demo (Carne Asada, Pollo, Refresco)</li>
              <li>• 1 paquete demo (Combo Familiar)</li>
              <li>• 2 mesas (Mesa 1 y Mesa 2)</li>
              <li>• 1 mesero llamado "Cajero"</li>
            </ul>
            <p className="mt-2 text-xs text-slate-500">
              Podrás editarlos o borrarlos desde la sección correspondiente cuando quieras.
            </p>
          </div>
        )}
      </div>

      {error && (
        <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">{error}</div>
      )}

      <div className="flex justify-between">
        <button onClick={onAtras} className="btn-ghost btn-lg" disabled={enviando}>
          <ArrowLeft className="h-5 w-5" />
          Atrás
        </button>
        <button onClick={handleFinalizar} className="btn-primary btn-lg" disabled={enviando}>
          <Check className="h-5 w-5" />
          Empezar a vender
        </button>
      </div>
    </div>
  );
}
